export default {
  page_title: "Favoritos",
  select_banner: "Escolher Banner(s)",
  seen_my_landing_page: "Ver minha landing page",
  no_lp_carousels: "Nenhum banner para escolher por enquanto",
  shareWithFriends: "Compartilhe com seus amigos!"
};
